import ConstructionStatus from "../../../../dto/construction/ConstructionStatus";
import { getFromLocalStorage } from "../../../../utils/ManageLocalStorage";
import type ConstructionCalculationsNewHeaderProps from "./ConstructionCalculationsNewHeaderProps";
import styles from "../../constructionCalculationsNew.module.scss";
import headerStyles from "./constructionCalculationHeader.module.scss";
import { Icon, MessageBar, MessageBarType } from "@fluentui/react";
import CalculationTagsNew from "../tags/CalculationTagsNew";
import CalculationNavigationNew from "../navigation/CalculationNavigationNew";
import IsaacPills from "../../../../components/isaacPills/IsaacPills";
import CalculationCommandBarNew from "../commandBar/CalculationCommandBarNew";

const ConstructionCalculationsNewHeader: React.FunctionComponent<ConstructionCalculationsNewHeaderProps> = ({
        construction,
        calculations,
        selectedCalculationResults,
        commandBarItems,
        commandBarFarItems
}) => {
    const localStorageStatus = getFromLocalStorage<boolean>(`${construction?.id}.inProgress`);
    const profilesAreValid = selectedCalculationResults?.profilesAreValid ?? false;
    const sourceCalculationId = calculations.find(c => c.isUsedToUpdateConstruction)?.calculationId;
    const constructionAccepted = construction?.status === ConstructionStatus.Accepted;
    const constructionNameClassName: string = calculations.length > 0 
        ? profilesAreValid 
            ? styles.valid
            : styles.notValid
        : styles.notProcessed;
    const constructionAcceptedClassName: string = constructionAccepted
        ? styles.isAccepted
        : "";

    return (
        <>
        {construction && (
                <div className={styles.header}>
                  <div className={headerStyles.constructionHeaderContainer}>
                    <h2 className={`${constructionNameClassName} ${constructionAcceptedClassName}`}>
                      {construction?.name}
                    </h2>
                    {constructionAccepted && (
                      <Icon
                        iconName="CheckboxCompositeReversed"
                        className={headerStyles.isAccepted}
                        title="Construction is accepted. No changes can be performed."
                      />
                    )}
                    {selectedCalculationResults?.calculationId !== undefined &&
                      selectedCalculationResults?.calculationId === sourceCalculationId && (
                        <h3 className={headerStyles.updatedWithResult}>
                          Construction updated with this result
                        </h3>
                      )}
                    <CalculationTagsNew construction={construction} />
                    <div className={headerStyles.right}>
                      <CalculationNavigationNew />
                    </div>
                  </div>
                  {localStorageStatus && (
                    <MessageBar
                      messageBarType={MessageBarType.warning}
                      className={styles.noPrint}>
                      Construction calculation in progress. You will receive a
                      notification upon completion.
                    </MessageBar>
                  )}
                  <IsaacPills
                    pills={[
                      {name: "Location type", value: construction.constructionDetails.location.type.value},
                      {name: "Location code", value: construction.constructionDetails.location.code.value},
                      {name: "Phase", value: construction.constructionDetails.location.phase.value},
                    ]}
                  />
                  <div className={styles.commandBar}>
                    <CalculationCommandBarNew
                      hasCalculations={calculations.length > 0}
                      commandBarItems={commandBarItems}
                      commandBarFarItems={commandBarFarItems}
                    />
                  </div>
                </div>
              )}
        </>
    )
};

export default ConstructionCalculationsNewHeader;